import { Button, Card, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { loginLocal } from 'api/api';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import Box from '@mui/material/Box';
import { useMedia } from 'react-use';

const SignIn = () => {
  const [loginError, setLoginError] = useState<any>();
  const queryClient = useQueryClient();
  const isDarkTheme = useMedia('(prefers-color-scheme: dark)');
  const { mutateAsync } = useMutation('loginLocal', loginLocal, {
    onSettled: (data) => {
      queryClient.invalidateQueries('profile');
    },
  });

  const isWide = useMedia('(min-width: 600px)');

  return (
    <Box className="flex flex-col gap-2 justify-center items-center w-full">
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        onSubmit={async ({ email, password }, { setSubmitting }) => {
          try {
            await mutateAsync({ email, password });
          } catch (error: any) {
            setLoginError(error);
          }

          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting }) => (
          <Form style={{ width: '100%' }}>
            <Card
              variant="outlined"
              sx={{
                width: '100%',
                maxWidth: '450px',
                borderWidth: isDarkTheme ? '0px' : '1px',
                padding: { xs: '16px 16px 24px', sm: '40px' },
                margin: { xs: '16px auto 0', sm: '60px auto 0' },
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                position: 'relative',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  textAlign: 'center',
                  mt: 1,
                  mb: 2,
                  fontSize: '1.8rem',
                }}
              >
                Sign in
              </Typography>
              <Field
                size="small"
                component={TextField}
                label="Email"
                name="email"
                sx={{ width: '100%' }}
              />
              <Field
                size="small"
                component={TextField}
                type="password"
                label="Password"
                name="password"
                sx={{ width: '100%' }}
              />
              {loginError && (
                <Box sx={{ color: '#d93025' }}>
                  {!!loginError.message ? loginError.message : loginError}
                </Box>
              )}
              <Box
                sx={{
                  textAlign: 'right',
                  mt: 2,
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <Box sx={{ flex: '1 1 auto' }} />
                <Box
                  sx={{
                    textAlign: 'right',
                    margin: { xs: '0 0 16px', sm: '16px 0' },
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={isSubmitting}
                    onClick={submitForm}
                    sx={{ padding: '6px 24px' }}
                  >
                    Login
                  </Button>
                </Box>
              </Box>
              <Box sx={{ mt: 2 }}>
                <Button
                  href="api/auth/google"
                  variant="contained"
                  startIcon={<GoogleIcon />}
                >
                  Sign in with Google
                </Button>
              </Box>
            </Card>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default SignIn;
